import { render } from "./ShowCourseDetails.vue?vue&type=template&id=68f7263f"
import script from "./ShowCourseDetails.vue?vue&type=script&lang=js"
export * from "./ShowCourseDetails.vue?vue&type=script&lang=js"

import "./ShowCourseDetails.vue?vue&type=style&index=0&id=68f7263f&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__